// Owner-facing strings for "What George knows about you" (George P4-2).
// The coach's name is per tenant.

export const KIND_ORDER = [
  'What you want', 'Your timeline', 'People in your plans', 'Why you are doing this', 'What worries you',
  'Things to work around', 'How ready the business is', 'How you like to work', 'Things you shared',
];

export const UNDERSTANDING_COPY = {
  eyebrow: (coach) => `What ${coach} knows`,
  heading: (coach) => `What ${coach} knows about you`,
  intro: (coach) =>
    `${coach} uses this to pick up where you left off and to ask the right questions. Only you and ${coach} see it, ` +
    'and nothing here is shared with anyone unless you say so. Correct anything that is wrong, or delete it.',
  updated: (date) => `Last updated ${date}`,
  empty: (coach) =>
    `Nothing yet. As you talk, ${coach} will remember what matters to you and it will show up here.`,
  basis: {
    stated: 'You said this',
    observed: 'From what you did',
    inferred: (coach) => `${coach}'s read`,
  },
  confirmed: 'Confirmed',
  corrected: 'Corrected by you',
  private: 'Private',
  privateHint: (coach) => `Personal: only you and ${coach} ever see this, even when sharing is on.`,
  from: 'From',
  thatsRight: "That's right",
  correct: 'Correct it',
  save: 'Save',
  cancel: 'Cancel',
  delete: 'Delete',
  correctPlaceholder: 'What is right, in a sentence',
  memoriesHeading: (coach) => `Things you told ${coach}`,
  memoriesIntro: (coach) => `Deleting one also removes anything ${coach} built on it.`,
  forgetHeading: 'Start over',
  forgetIntro: (coach) =>
    `Delete everything ${coach} remembers and understands about you, and start over. Your conversation stays on ` +
    `screen, but ${coach} will no longer read it or use anything from before. Your profile and saved results ` +
    'stay.',
  forgetButton: 'Forget everything',
  forgetConfirm: 'Yes, forget everything',
  forgetAsk: 'This cannot be undone. Continue?',
  sharingHeading: 'Sharing with partners',
  sharingIntro: (coach) =>
    `When ${coach} introduces you to a partner, you can send them a short brief. Choose what it may draw on. ` +
    'Private things are never shared, and you approve every brief before it goes.',
  sharingSave: 'Save sharing',
  sharingOff: 'Stop sharing',
  sharingOffNote: 'Sharing is off. Introductions still work; they just go without a brief.',
  sharingSince: (date) => `Sharing since ${date}`,
  briefsHeading: 'Briefs you sent',
  briefReads: (n) => (n === 1 ? 'Read once' : `Read ${n} times`),
  briefUnread: 'Not read yet',
  briefHidden: 'No longer showing',
  briefCannotRecall: 'A sent brief cannot be recalled. Stopping sharing hides it from now on.',
  // Succeedo Phase 5: sharing with the owner's own advisor.
  advisorSharingHeading: (name) => `Sharing with your advisor, ${name}`,
  advisorSharingIntro: (coach, name) =>
    `When you send ${name} a brief about something you want help with, ${coach} drafts it from that and from ` +
    'what you choose here. Private things are never included, and you approve every word.',
  advisorSharingOffNote: 'Nothing extra is shared. Briefs to your advisor still work; they just say less.',
  advisorBriefCannotRecall: 'A sent brief cannot be recalled. Removing your advisor from your team hides it from then on.',
  actionFailed: 'That did not save. Please try again.',
  loading: 'Loading…',
  error: "This page couldn't load. Please refresh.",
};
